<template>
    <div class="grafico-container">
        <div class="grafico-header">
            <h3 class="grafico-titulo">Distribuição de Status dos Projetos</h3>
            <GraficoInfoIcon 
                titulo="Distribuição de Status dos Projetos"
                descricao="Mostra a proporção de projetos por status, permitindo visualizar a distribuição geral do portfólio."
            />
        </div>
        <div v-if="!temDados" class="sem-dados">Nenhum dado disponível</div>
        <Doughnut v-else :data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import GraficoInfoIcon from './GraficoInfoIcon.vue';

ChartJS.register(ArcElement, Tooltip, Legend);

export default {
    name: 'GraficoStatusProjetosPizza',
    components: { Doughnut, GraficoInfoIcon },
    props: {
        projetos: {
            type: Array,
            default: () => []
        }
    },
    emits: ['clicar-projeto'],
    computed: {
        dadosStatus() {
            const statusMap = {};
            this.projetos.forEach(p => {
                const status = p.status || 'Sem Status';
                statusMap[status] = (statusMap[status] || 0) + 1;
            });
            return Object.entries(statusMap).map(([status, count]) => ({ status, count }));
        },
        temDados() {
            return this.dadosStatus.length > 0;
        },
        chartData() {
            const cores = [
                'rgba(54, 117, 211, 0.8)',
                'rgba(46, 204, 113, 0.8)',
                'rgba(241, 196, 15, 0.8)',
                'rgba(231, 76, 60, 0.8)',
                'rgba(155, 89, 182, 0.8)',
                'rgba(52, 73, 94, 0.8)',
                'rgba(26, 188, 156, 0.8)',
                'rgba(230, 126, 34, 0.8)'
            ];
            
            return {
                labels: this.dadosStatus.map(d => d.status),
                datasets: [{
                    data: this.dadosStatus.map(d => d.count),
                    backgroundColor: this.dadosStatus.map((_, index) => cores[index % cores.length]),
                    borderWidth: 2,
                    borderColor: '#fff'
                }]
            };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'right',
                        labels: {
                            padding: 15,
                            usePointStyle: true
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                const label = context.label || '';
                                const value = context.parsed || 0;
                                const total = this.projetos.length;
                                const porcentagem = ((value / total) * 100).toFixed(1);
                                return `${label}: ${value} (${porcentagem}%)`;
                            }
                        }
                    }
                }
            };
        }
    }
};
</script>

<style scoped>
.grafico-container {
    background: var(--cor-bg, white);
    border: 1px solid var(--cor-separador, #ddd);
    border-radius: 8px;
    padding: 1.5rem;
    height: 500px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
}

.grafico-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.grafico-titulo {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--cor-fonte, #333);
}

.sem-dados {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
}
</style>

